/**
 * Memoize a function
 *
 * @category Helpers
 */
export function memoize(inputFn, resolver = JSON.stringify) {
    const cache = new Map();
    const memoizedFn = (...args) => {
        const key = resolver(args);
        if (!cache.has(key)) {
            cache.set(key, inputFn(...args));
        }
        // we know it exist because we set if above
        return cache.get(key);
    };
    return memoizedFn;
}
//# sourceMappingURL=memoize.js.map